const ASSETS_URL = "https://d135lw6vh1h84k.cloudfront.net";

export { ASSETS_URL };



// WEBPACK FOOTER //
// ./src/constants.js